// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
   background-color: #f5f5f5;
   width: 600px;
   min-width: 600px;
   max-width: 600px;
   overflow-y: auto;
   max-height: 400px;
   min-height: 400px;
}

ul.doclist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
}
ul.doclist li {
   padding: 5px 10px;
}
ul.doclist a {
   cursor: pointer;
   color: #666;
}
ul.doclist a.selectedRoot {
   color: #00bed6;
}

.mat-dialog-content {
   overflow: hidden;
}
.mat-dialog-title {
   font-size: 18px;
   word-break: break-all;
   width: 600px;
}

img {
   width: 20px;
   height: 20px;
   vertical-align: top;
   margin-right: 5px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/onedrive-move-dialog/onedrive-move-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,gBAAgB;GAChB,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;AACb;AACA;GACG,iBAAiB;AACpB;AACA;GACG,eAAe;GACf,WAAW;AACd;AACA;GACG,cAAc;AACjB;;AAEA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;GACf,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".main {\n   background-color: #f5f5f5;\n   width: 600px;\n   min-width: 600px;\n   max-width: 600px;\n   overflow-y: auto;\n   max-height: 400px;\n   min-height: 400px;\n}\n\nul.doclist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n}\nul.doclist li {\n   padding: 5px 10px;\n}\nul.doclist a {\n   cursor: pointer;\n   color: #666;\n}\nul.doclist a.selectedRoot {\n   color: #00bed6;\n}\n\n.mat-dialog-content {\n   overflow: hidden;\n}\n.mat-dialog-title {\n   font-size: 18px;\n   word-break: break-all;\n   width: 600px;\n}\n\nimg {\n   width: 20px;\n   height: 20px;\n   vertical-align: top;\n   margin-right: 5px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
